<script>
import { mapState } from 'vuex'
import PetDisplay from '@/components/PetDisplay.vue'
import Rainbow from '@/components/Rainbow.vue'

export default {
  name: 'Thankyou',
  components: {
    PetDisplay,
    Rainbow,
  },
  mounted() {
    this.$scrollTo(`#app`, 500, { offset: 0, easing: 'ease-in-out', })
    this.$store.dispatch('signup/SET_STEP', 0)
  },
  computed: {
    ...mapState({
      selectedPractice: state => state.selectedPractice,
      signup: state => state.signup,
    }),
  },
  methods: {
    // bookOnline() {
    //   window.open(this.selectedPractice.bookOnline, '_blank')
    // },
  },
}
</script>

<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="inset">
      <h1 class="mt-8">Thank You</h1>
      <h2 class="mt-1">Membership Enrollment Successful</h2>
      <Rainbow style="width: 150px;" class="mb-8" thickness="8px" />
      Please allow one business day for the enrollment process to complete.<br />
      Welcome to Healthy Pet + !
      <v-divider class="my-8" light></v-divider>
      <PetDisplay />
      <v-divider class="mt-8" light></v-divider>
    </v-col>
    <v-col cols="12">
      <h2>Schedule an Appointment</h2>
      <p>Now that you're a member of Healthy Pet+, take advantage of your new membership by scheduling your pet's next appointment.</p>
    </v-col>
    <v-col cols="12">
      <!-- <v-btn @click="bookOnline" large class="greenbtn">BOOK ONLINE</v-btn> -->
      <div class="mt-4 clinicphone">{{ selectedPractice.phone }}</div>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  h2 {
    font-size: 32px;
    color: $hpp-darkblue;
  }
  .clinicphone {
    font-weight: bold;
    color: $hpp-darkblue;
    font-size: 28px;
  }
</style>
